<template>
	<el-button v-if="$HasPermission(permissions)" :disabled="disabled" type="primary" @click="handleClick">
		<slot>{{label}}</slot>
	</el-button>
	<el-tooltip v-else content="无权限,请联系商务" placement="top" effect="light">
		<span>
			<el-button type="primary" :disabled="true">
				<slot>{{label}}</slot>
			</el-button>
		</span>
	</el-tooltip>
</template>

<script>
	export default {
		props: ['permissions', 'label', 'type','disabled'],
		methods:{
			handleClick(){
				this.$emit('buttonClick',this.label)
			}
		},
	}
</script>

<style lang="less" scoped>
</style>
